export default __webpack_public_path__ + "static/media/ils_03.33257d71.svg";